module.exports = __webpack_public_path__ + "static/Up to Date Document 3-5f514a0a4bd30428de1a0564b5ef3b68.png";